import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { updateIdolEntities } from './idols.actions';
import { AppState } from '../../reducers';
import * as R from 'ramda';
import {IdolProfileImage} from '../../../modules/IdolCreate';

export interface IdolSourceCategory {
  id: number;
}

export interface AppQuality {
  id: number;
  name: string;
  quality: string;
}

export interface Idol {
  id: number;
  name: string;
  gender: string;
  slug: string;
  firstname?: string;
  lastname?: string;
  appIds?: number[];
  apps?: AppQuality[];
  quality?: string;
  qualities?: {
    [key: number]: string;
  };
  images?: IdolProfileImage[];
}

export interface Idols {
  byId: {
    [key: string]: Idol;
  };
}

const initialState = Immutable.from<Idols>({ byId: {} });
export type IdolState = Idols & Immutable.ImmutableObject<Idols>;

export default function reduce(
  state: IdolState = initialState,
  action: Action
) {
  if (isType(action, updateIdolEntities)) {
    const { payload } = action;
    return state.merge({ byId: payload }, { deep: true });
  }

  return state;
}

export function getIdols(state: AppState) {
  const {
    entities: { idols },
  } = state;

  return idols && idols.byId && R.values(idols.byId);
}

export function getIdolById(state: AppState, idolId: number): Idol | undefined {
  const {
    entities: { idols },
  } = state;
  return idols && idols.byId && idols.byId[idolId];
}

export function getIdolBySlug(state: AppState, slug: string): Idol | undefined {
  const {
    entities: { idols },
  } = state;
  if (!idols || !idols.byId) {
    return;
  }
  return R.find(R.propEq('slug', slug))(R.values(idols.byId)) as
    | Idol
    | undefined;
}

export function getIdolByName(state: AppState, name: string): Idol | undefined {
  const {
    entities: { idols },
  } = state;
  if (!idols || !idols.byId) {
    return;
  }
  return R.find(R.propEq('name', name))(R.values(idols.byId)) as
    | Idol
    | undefined;
}



// WEBPACK FOOTER //
// ./src/store/Entities/Idols/idols.reducer.ts